import React from 'react';
import { Button } from 'reactstrap';
import { groupBy, sortBy, get, omit, keyBy, chunk, } from 'lodash';
import { Link } from 'react-router-dom';
import { useToggle } from 'react-use';
import { toast } from 'react-toastify';
import { omitBy, } from 'lodash';

import firebase, { functions, } from '../../firebase';
import { adminFields, plans, } from '../../shared/models/tenant';
import { fieldDisplayValue, } from '../../shared/util';
import { batch, } from '../../shared/firebase';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import useQueryParams from '../hooks/useQueryParams';
import AdminPage from '../hocs/AdminPage';
import ProgressButton from '../ProgressButton';
import ModelFormModal from '../modals/ModelFormModal';
import EditButton from '../EditButton';
import QueryBoolean from '../QueryBoolean';
import ModalButton from '../ModalButton';
import TagsManagementModal from '../modals/TagsManagementModal';
import ExportButton from '../ExportButton';
import ImportButton from '../ImportButton';
import TenantTags from '../TenantTags';

const db = firebase.firestore();
const tenantsRef = db.collection('tenants');
const usersRef = db.collection('users');
const tagsRef = db.collection('tags');

export default AdminPage(function AdminTenants (props) {
  const { user } = props;
  const {
    onlyNotSatisfied = '0',
  } = useQueryParams();
  const [showsFormModal, toggleFormModal] = useToggle(false);
  const tenants = useCollectionSubscription(tenantsRef.orderBy('createdAt'));
  const users = useCollectionSubscription(usersRef);
  const tags = useCollectionSubscription(tagsRef.orderBy('createdAt'));
  const usersGroupedByTenantId = groupBy(users, 'tenantId');
  const tagsById = keyBy(tags, 'id');
  const tagsByName = keyBy(tags, 'name');
  let filteredTenants = tenants;
  if(onlyNotSatisfied === '1') {
    filteredTenants = filteredTenants.filter(_ => _.plan == null || _.referrer == null);
  }

  const exportRows = () => {
    return tenants.map(_ => ({
      テナントID: _.id,
      テナント名: _.name,
      タグ: (_.tagIds ?? []).map(tagId => tagsById[tagId]?.name).filter(_ => _).join(','),
    }));
  };

  const processImportRows = async (rows) => {
    const updates = rows.map(_ => ({
      tenantId: _.テナントID,
      tagNames: (_.タグ ?? '').split(',').map(_ => _.trim()).filter(_ => _),
    })).filter(_ => _.tenantId);

    await batch(db, updates, (b, { tenantId, tagNames }) => {
      const tagIds = tagNames.map(name => tagsByName[name]?.id).filter(_ => _);
      b.update(tenantsRef.doc(tenantId), { tagIds });
    });
  };

  return (
    <div className="admin-tenants container-fluid">
      <div className="p-4 bg-white my-4">
        <div className="d-flex justify-content-center mb-3">
          <h4>テナント管理</h4>
        </div>
        <div className="mt-3 d-flex align-items-end flex-wrap justify-content-between">
          <QueryBoolean paramName="onlyNotSatisfied" label="必須設定が必要なもののみ" defaultValue={'0'} />
          <div className="d-flex gap-1">
            <ExportButton
              rows={exportRows}
              fileName="テナント一覧.csv"
            />
            <ImportButton
              processRows={processImportRows}
              label="タグインポート"
            />
            <ModalButton
              Modal={TagsManagementModal}
              label="タグ管理"
              color="secondary"
            />
          </div>
        </div>
        <div className="mt-4 overflow-scroll">
          <table className="table sticky-table">
            <thead className="thead-light text-center">
              <tr className="text-nowrap">
                <th>ID</th>
                <th>テナント名</th>
                <th>ユーザー</th>
                <th>プラン</th>
                <th>紹介者</th>
                <th style={{ minWidth: 150 }}>オプション</th>
                <th>管理者メモ</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {
                filteredTenants.map((tenant) => {
                  const { id, ref, name, plan, referrer, tenantOptionValues, allowsMultiNeko = false, tagIds, adminNote, } = tenant;
                  const users = usersGroupedByTenantId[id];
                  const changeTenant = async () => {
                    if(!window.confirm(`${name}のユーザーになります。よろしいですか？`)) return;

                    await user.ref.update({ tenantId: id });
                  };

                  return (
                    <tr key={id}>
                      <td>
                        <Link to={`/admin/tenants/${id}`}>
                          {id}
                        </Link>
                      </td>
                      <td>
                        <div>{tenant.name}</div>
                        {allowsMultiNeko && <div className="badge badge-info">複数でもネコポス</div>}
                        <TenantTags tagIds={tagIds} tagsById={tagsById} />
                      </td>
                      <td>
                        {
                          users?.map((user) => {
                            const { id, displayName, email, phone } = user;
                            return (
                              <div key={id}>
                                {displayName} &lt;{email}&gt; ({phone})
                              </div>
                            );
                          })
                        }
                      </td>
                      <td>
                        {plans[plan]?.label}
                      </td>
                      <td>
                        {referrer}
                      </td>
                      <td>
                        {fieldDisplayValue(tenantOptionValues, adminFields.tenantOptionValues)}
                      </td>
                      <td style={{ whiteSpace: 'pre-line', }}>
                        {adminNote}
                      </td>
                      <td className="text-nowrap text-right">
                        <EditButton itemRef={ref} FormModal={ModelFormModal} formProps={{ title: 'ユーザー 編集', fields: adminFields({ tags }), }} />
                        <ProgressButton className="ml-1" label="このテナントのユーザーになる" process={changeTenant} disabled={user.tenantId === id} />
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
});
